import styled from "styled-components"

import { eq, when, minWidth, maxWidth } from "utils"

import Grid from "components/grid"

export const Container = styled.section`
  margin-bottom: 6rem;
  padding: 6rem 0 0;
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  background-color: ${({ theme }) => theme.component.background};
  color: ${({ theme }) => theme.component.text};

  ${when("largeOuterPadding")`
    padding: 6rem 8.5rem;
  `}

  ${maxWidth.largest`
    padding-left: 10rem;
    padding-right: 10rem;
  `}

  ${maxWidth.desktopL`
    padding: 6rem;
  `}

  ${maxWidth.tablet`
    padding-left: 5rem 2rem 4rem;
    padding-right: 2rem;
  `}

  ${maxWidth.mobile`
    padding: 3rem 2rem;
  `}
`

export const Content = styled.div`
  ${when("hasMindbodygreenTitle")`
    position: relative;
    top: -4rem;
    margin-bottom: -4rem;

    ${minWidth.mobileS`
      top: -4.2rem;
      margin-bottom: -4.2rem;
    `}

    ${minWidth.mobileM`
      top: -4.4rem;
      margin-bottom: -4.4rem;
    `}

    ${minWidth.mobile`
      top: -5.1rem;
      margin-bottom: -5.1rem;
    `}

    ${minWidth.hamburgerLarge`
      top: -5.6rem;
      margin-bottom: -5.6rem;
    `}
  `}
`

export const JumboWrapper = styled.section`
  padding-top: 0.6rem;
  background-color: ${({ theme }) => theme.component.background};
`

export const Inner = styled.div`
  padding-top: 0.6rem;
  display: flex;

  flex-wrap: wrap;
  background-color: ${({ theme }) => theme.component.background};

  ${maxWidth.mobile`
    display: block;
  `}

  > :first-child {
    flex: 0 0 ${({ leftWidth }) => (leftWidth ? `${leftWidth}%` : "39%")};

    ${when("largeColMargin")`
      padding-right: 2rem;
    `}

    ${eq("numItems", 3)`
      flex: 0 0 65%;
    `}

    ${maxWidth.desktop`
      flex: 1 0 100%;
      padding-right: 0;
    `}
  }

  > :nth-child(2) {
    flex: 0 0 ${({ leftWidth }) => (leftWidth ? `${100 - leftWidth}%` : "61%")};

    ${when("largeColMargin")`
      padding-left: 0;
    `}

    ${eq("numItems", 3)`
      flex: 0 0 35%;
    `}

    ${maxWidth.desktop`
      flex: 1 0 100%;
    `}
  }
`

export const DesktopWrapper = styled.div`
  ${maxWidth.mobile`
    display: none;
  `}
`

export const MobileWrapper = styled.div`
  display: none;

  ${maxWidth.mobile`
    display: block;
  `}
`

export const ScrollLabel = styled.div`
  margin-top: 1.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.62rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const ScrollContainer = styled.div`
  width: 100%;
`

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const CustomGrid = styled(Grid)`
  padding: 0 0 0 0.6rem;
  flex: 1 0 auto;
  background: inherit;

  ${maxWidth.desktop`
    width: 100%;
    padding: 0.6rem 0 0 0;
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${when("bottom")`
    margin-top: 3rem;

    ${maxWidth.mobile`
      button {
        width: 100%;
      }
    `}
  `}
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: "space-between";
`

export const TextLinkCardsContainer = styled.div`
  display: none;

  ${minWidth.mobile`
    display:flex;
    gap: 2.4rem;
    margin-top:0.5rem;
  `}
`
